import { FieldDropDownList } from 'components/common-form/builder/form/node/field/ListField';
import { useHasFieldMetadata } from 'components/common-form/hooks/useHasFieldMetadata';
import { usePatchedFieldHighlight } from 'components/common-form/hooks/usePatchedFieldHighlight';
import { FC } from 'react';

export const StrikeMode: FC = () => {
  const hasStrikeMode = useHasFieldMetadata('StrikeMode');
  const patchedFieldClassName = usePatchedFieldHighlight('StrikeMode');
  return (
    hasStrikeMode && (
      <div className={patchedFieldClassName}>
        <FieldDropDownList id="StrikeMode" className="fs-6 ps-2" />
      </div>
    )
  );
};
StrikeMode.displayName = 'StrikeMode';
